var React = require('react');

function IconMapMarkerInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"currentColor","d":"M14 35c9.333-8.845 14-15.845 14-21 0-7.732-6.268-14-14-14S0 6.268 0 14c0 5.155 4.667 12.155 14 21z","key":0}),React.createElement("circle",{"cx":"14","cy":"14","r":"7","fill":"#FFF","key":1})]));
}

IconMapMarkerInline.defaultProps = {"width":"28","height":"35"};

module.exports = IconMapMarkerInline;

IconMapMarkerInline.default = IconMapMarkerInline;
